import scriptLoader from "./scriptLoader";

export default ( robot, scripts ) => {
  return scriptLoader( robot, scripts );
};
